import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import RNButton from '@/components/common/residents/desktop/Button';

type DesktopHeaderCardProps = {
  icon?: React.ReactNode;
  title: string;
  subtitleLines?: string[];
  ctaText?: string;
  onPressCta?: () => void;
  style?: ViewStyle;
};

export const DesktopHeaderCard: React.FC<DesktopHeaderCardProps> = ({
  icon,
  title,
  subtitleLines = [],
  ctaText,
  onPressCta,
  style,
}) => {
  return (
    <View style={[styles.card, style]}> 
      {icon}
      <View style={styles.textCol}>
        <Text style={styles.title}>{title}</Text>
        {subtitleLines.map((line, idx) => (
          <Text key={idx} style={styles.subtitle}>{line}</Text>
        ))}
      </View>
      {!!ctaText && !!onPressCta && (
        <RNButton title={ctaText} onPress={onPressCta} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: 16, // Matches resio-web rounded-2xl (16px)
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    flexDirection: 'row',
    padding: 24, // Matches resio-web p-6 (24px)
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderWidth: 1,
    borderColor: '#2f2f2f',
  },
  textCol: {
    flexDirection: 'column',
    marginLeft: 12,
    flex: 1,
  },
  title: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 18,
    fontWeight: '600',
  },
  subtitle: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    fontSize: 14,
    marginTop: 8,
  },
  button: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.BUTTON_TERTIARY,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  buttonText: {
    color: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    fontWeight: '700',
  },
});

export default DesktopHeaderCard;


